import { SandboxApp as SandboxPageView } from "../components/SandboxApp";

/** Route entry for the sandbox / space viewer */
export function SandboxPage() {
  return <SandboxPageView />;
}
